import { UseFormSetError } from "react-hook-form/dist/types/form";

import type { Patient } from "services/types/patients.type";
import { formatBirthdate, formatPhoneNumber } from "utils/common";

const getPhoneNumber = (value?: string) =>
  value ? formatPhoneNumber(value) : value;

export const mapPatientForProfile = (patient?: Patient) => {
  return {
    ...patient,
    referring_physician_phone: getPhoneNumber(
      patient?.referring_physician_phone
    ),
    phone: getPhoneNumber(patient?.phone),
    secondary_phone: getPhoneNumber(patient?.secondary_phone),
    emergency_contact_phone: getPhoneNumber(patient?.emergency_contact_phone),
    secondary_emergency_contact_phone: getPhoneNumber(
      patient?.secondary_emergency_contact_phone
    ),
    tertiary_emergency_contact_phone: getPhoneNumber(
      patient?.tertiary_emergency_contact_phone
    ),
    birthdate: formatBirthdate(patient?.birthdate)
    // This is due to timezone issues with "YYYY-MM-DD"
  };
};

export const setErrorsFromBackedToForm = ({
  errors,
  setError
}: {
  errors: Record<string, { message: string; code: string }[]>;
  setError: UseFormSetError<any>;
}) => {
  Object.entries(errors).map(([key, value]) => {
    const message = value?.[0].message;

    return message && setError(key, { message: message });
  });
};
